import { Stack } from '@/components/layout';
import { DetailInfoTemplate } from '@/components/template/detail-info/detail-info-template';
import { ButtonConfigInactiveFilter } from '@/features/coach/components/detail-coach/button-config-inactive-filter';
import { DetailCoachContent } from '@/features/coach/components/detail-coach/detail-content';
import { DetailCoachHeader } from '@/features/coach/components/detail-coach/detail-header';
import { DetailCoachTop } from '@/features/coach/components/detail-coach/detail-top';
import { useCoachQuery } from '@/features/home/queries';
import { homeKeys } from '@/features/home/queries/query-keys';
import { useScaling } from '@/hooks/use-scaling';
import { useSessionStore } from '@/stores/session-store';
import { useUiStore } from '@/stores/ui-store';
import { useQueryClient } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';

export function DetailCoachScreen() {
  const { scale } = useScaling();
  const queryClient = useQueryClient();
  const uid = useSessionStore(useShallow(state => state.user?.uid));
  const showGlobalLoading = useUiStore(useShallow(s => s.showGlobalLoading));
  const hideGlobalLoading = useUiStore(useShallow(s => s.hideGlobalLoading));
  const { data: coach, refetch: refetchCoach } = useCoachQuery(uid);

  const onRefresh = async () => {
    try {
      showGlobalLoading();
      await refetchCoach();
      queryClient.invalidateQueries({ queryKey: homeKeys.coach(coach?.id) });
    } finally {
      hideGlobalLoading();
    }
  };

  return (
    <Stack flex={1}>
      <DetailInfoTemplate
        header={<DetailCoachHeader />}
        top={<DetailCoachTop />}
        mobileContent={
          <Stack backgroundColor="white" paddingTop={scale(4)} gap={scale(8)}>
            <ButtonConfigInactiveFilter />
            <DetailCoachContent />
          </Stack>
        }
        tabletLeftContent={<DetailCoachContent />}
        tabletRightContent={
          <Stack paddingTop={scale(30)}>
            <ButtonConfigInactiveFilter />
          </Stack>
        }
        onRefresh={onRefresh}
        isMobileRefreshing={false}
        isTabletRefreshing={false}
        tabletLeftPaneWidth={scale(375)}
        mobileStickyHeaderIndices={[1]}
      />
    </Stack>
  );
}
